import ConversionBar from 'components/Shared/ConversionBar';
import GetInTouch from 'components/Shared/GetInTouch';
import PreviouslyFeaturedOn from 'components/Shared/PreviouslyFeaturedOn';
import Reviews from 'components/Shared/Reviews/Reviews';
import TrustBanner from 'components/Shared/TrustBanner';
import Layout from 'components/ui/Layout';
import { useTranslation } from 'hooks/useTranslation';
import Hero from './Hero';
import Testimonials from './Testimonials';
import type { Brand } from 'types/Brand';
import type { IFooter } from 'types/contentful/generated';
import type { FooterItemType } from 'types/Footer';
import type { ReviewItem } from 'types/Review';

type Props = {
  footer: IFooter | FooterItemType | null | undefined;
  resultState: ReviewItem[];
  brand: Brand | null;
};

const ReviewsPage = ({ footer, resultState, brand }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Layout
      title={`${t('reviewsPage.metaTitle')} | ${t('qunomedical')}`}
      metaDescription={t('reviewsPage.metaDescription')}
      alternateSlugs={[
        { locale: 'de', slug: 'bewertungen' },
        { locale: 'en', slug: 'reviews' },
      ]}
      footer={footer}
      noMetaTitle={t('reviews')}
      brand={brand}
    >
      <Hero />
      <Testimonials />
      <TrustBanner />
      <div className="max-w-screen-xl mx-auto px-0 md:px-4 py-0">
        <Reviews
          reviews={resultState}
          sideContent={
            <p className="text-charcoal leading-8 md:leading-normal mb-20 md:mb-16">
              {t('realPatientsHonestPatients.text')}
            </p>
          }
          noGrid
        />
      </div>
      <PreviouslyFeaturedOn className="mb-20" />
      <GetInTouch />
      <ConversionBar />
    </Layout>
  );
};

export default ReviewsPage;
